import get from 'lodash/get';
import { createMobileAnnouncementStepTemplate } from './mobile-step-template';
import { AiBlocks } from '@pendo/services/BuildingBlocks';

export function createGeneratedMobileAnnouncementTemplate ({ theme, generatedSteps, steps, platform }) {
    const newSteps = generatedSteps.map((step, index) => {
        return createMobileAnnouncementStepTemplate({
            theme,
            platform,
            width: 360,
            stepArtifact: step,
            stepBlocks: get(steps, `[${index}].buildingBlocks`),
        });
    });

    return AiBlocks.prepStepsForPreview(newSteps, steps, theme);
}
